import { ApolloClient } from '@apollo/client';
import { PublicClientApplication } from "@azure/msal-browser";
import { getScopes } from './msal';
import { createCache } from './cache';
import { createAuthenticatedLink } from 'acma-spa/dist/apollo';

export const createClient = (baseUrl: string, msalClient: PublicClientApplication, b2cDomainName: string, persistedQueries: boolean) => {
  return new ApolloClient({
    link: createAuthenticatedLink(baseUrl, persistedQueries, msalClient, getScopes(b2cDomainName)),
    cache: createCache(),
  });
}